import { render, staticRenderFns } from "./CapitalApplicationAuditHistory.vue?vue&type=template&id=bf515e8c&scoped=true&"
import script from "./CapitalApplicationAuditHistory.vue?vue&type=script&lang=ts&"
export * from "./CapitalApplicationAuditHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalApplicationAuditHistory.vue?vue&type=style&index=0&id=bf515e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf515e8c",
  null
  
)

export default component.exports